import { Footer } from '@/components/Footer'
import { NavBar } from '@/components/nav-bar'

export const TermsAndConditions = () => {
  return (
    <div className="overflow-hidden h-full noScrollbar w-full">
      <NavBar />
      <div className="max-w-3xl mx-auto p-6">
        <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
        <p className="text-sm font-semibold mb-6">Effective Date: April 5, 2025</p>

        <p className="mb-4">
          Welcome to <strong>DB8AI.com</strong>, a product by Symbollogic LLC (“Company”, “we”, “our”,
          or “us”). By using our website or purchasing our products and services, you agree to the
          following terms and conditions.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of Our Services</h2>
        <p className="mb-4">
          You must be at least 18 years old or have permission from a parent or guardian to use this
          site. You agree to use our services only for lawful purposes.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. Payment</h2>
        <p className="mb-4">
          Payments are processed securely via our partner, Paddle, and you agree to their terms when
          making a purchase.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Intellectual Property</h2>
        <p className="mb-4">
          All content, products, branding, and code available through our service are the property
          of Symbollogic LLC or its licensors. You may not reproduce, resell, or exploit any part of
          the service without our permission.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Disclaimer</h2>
        <p className="mb-4">
          Our products and services are provided "as is" without warranties of any kind. We do not
          guarantee uninterrupted or error-free service.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Limitation of Liability</h2>
        <p className="mb-4">
          We are not liable for any indirect, incidental, or consequential damages arising from your
          use of our services or products.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Governing Law</h2>
        <p className="mb-8">
          These terms are governed by the laws of the United States, and any disputes will be
          resolved in accordance with local jurisdiction.
        </p>

        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p className="mb-4">
          We respect your privacy. This Privacy Policy explains how we collect, use, and protect
          your personal information.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
        <p className="mb-4">
          We may collect your name, email, billing information, and usage data when you make a
          purchase or interact with our services.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Data</h2>
        <ul className="list-disc list-inside mb-4">
          <li>To deliver and manage your account or subscription</li>
          <li>To send transactional or marketing emails (you may opt-out at any time)</li>
          <li>To improve our service and prevent fraud</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Sharing</h2>
        <p className="mb-4">
          We do not sell your data. We only share it with third parties like Paddle to process
          payments securely and in accordance with privacy laws.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Retention</h2>
        <p className="mb-4">
          We keep your data only as long as necessary for legitimate business or legal purposes.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
        <p className="mb-8">You can contact us to access, correct, or delete your personal data.</p>

        <h1 className="text-3xl font-bold mb-4">Refund Policy</h1>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Digital Products and Subscriptions</h2>
        <p className="mb-4">Refunds may be issued within 14 days of purchase if:</p>
        <ul className="list-disc list-inside mb-4">
          <li>You did not receive access to the product</li>
          <li>You notify us with a valid reason for the refund request</li>
        </ul>
        <p className="mb-4">
          We reserve the right to deny refund requests in cases of abuse or extensive usage of the
          product before the request.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How to Request a Refund</h2>
        <p className="mb-4">
          Please contact our support team at{' '}
          <a href="mailto:support@symbollogic.com" className="text-blue-600 underline">
            support@symbollogic.com
          </a>{' '}
          with your order details. Refunds will be processed via Paddle and may take 5–10 business
          days to appear.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
        <p>If you have any questions about these terms or our policies, contact us at:</p>
        <p className="mt-2">
          📧{' '}
          <a href="mailto:support@symbollogic.com" className="text-blue-600 underline">
            support@symbollogic.com
          </a>
        </p>
      </div>

      <Footer />
    </div>
  )
}
